import { createContext } from 'react';
import { Page } from '../../types/__generated__';

export type PageMetaContext = {
  pageUrl: string;
  isInvite: boolean;
  isPreview: boolean;
  currentUrl: string;
  pageType: string;
  pageShortName: string;
  pageSlug: string;
  basePageData?: Page | null;
  metaTagImageUrl?: string;
  metaTagDescription?: string;
  error?: {
    status: number;
    messageKey: string;
  };
  showBanner?: boolean;
  bannerCopy?: string;
};

export const PageMetaContext = createContext<PageMetaContext | null>(null);

export const PageMetaContextProvider = PageMetaContext.Provider;
